export default "__VITE_ASSET__db0bdf54__"